import React, {useRef} from 'react'

export default function InputCode({codeValue, setCodeValue, e, isfocus, err}: any) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const digit = event.target.value.replace(/\D/g, '').slice(0, 1)
    setCodeValue((prev: any) => ({...prev, [e]: digit}))

    if (digit === '' && inputRef.current?.previousSibling instanceof HTMLElement) {
      inputRef.current.previousSibling.focus()
    } else if (digit !== '' && inputRef.current?.nextSibling instanceof HTMLElement) {
      inputRef.current.nextSibling.focus()
    }
  }

  return (
    <>
      <input
        ref={inputRef}
        style={{
          width: '52px',
          height: '60px',
          borderRadius: '8px',
          fontSize: '24px',
          color: '#2C3E6B',
          textAlign: 'center',
          border: `1px solid ${err ? 'red' : '#e1e3ea'}`,
          flexShrink: 0,
        }}
        type='text'
        inputMode='numeric'
        value={codeValue[e] ?? ''}
        maxLength={1}
        onChange={handleInputChange}
        className='input-code'
        autoFocus={e === isfocus}
      />
    </>
  )
}
